import { render } from "./SwitchList.vue?vue&type=template&id=0f12534f"
import script from "./SwitchList.vue?vue&type=script&lang=js"
export * from "./SwitchList.vue?vue&type=script&lang=js"

import "./SwitchList.vue?vue&type=style&index=0&id=0f12534f&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__